import type { GenericFormType } from '@neo/blocks/forms/types'
import { useCallback, useMemo } from 'react'
import { v2validations } from '../config/validation.config'
import { useGetLanguages, useGetProviders } from '../knowledge-base/queries'
import type { SidebarComponentProps, StreamNodeData } from '../types'
import { SUPPORTED_LANGUAGES } from '../utils/lang-utils'
import { GenericSidebarComponent } from './sidebar.base'
import {
  AudioModeCheckboxes,
  getBaseFields,
  // TextModeConfig,
} from './stream/stream-text-mode'
import type { FormValues } from './stream/stream-utils'

export const StreamSidebarComponent = (props: SidebarComponentProps<StreamNodeData>) => {
  const { nodeVars } = props
  const validations = v2validations({ nodeVars }).stream

  // Fetch providers for STT/TTS options
  const { data: providersData } = useGetProviders()
  const providers = providersData?.data

  // Fetch languages
  const { data: languagesData } = useGetLanguages((data) => ({
    ...data,
    data: {
      ...data.data,
      languages: data.data.languages.filter((lang) => SUPPORTED_LANGUAGES.includes(lang.code)),
    },
  }))
  const languages = languagesData?.data?.languages

  // Base fields
  const baseFields = useMemo(() => getBaseFields(validations), [validations])

  // All fields including both audio and text mode configs
  const allFields = useMemo(
    () => [
      ...baseFields,
      {
        name: 'audio_mode_checkboxes',
        type: 'slot' as const,
        element: ({ form }: { form: GenericFormType<FormValues> }) => (
          <AudioModeCheckboxes form={form} />
        ),
      },
      /* {
        name: 'text_mode_config',
        type: 'slot' as const,
        element: ({ form }: { form: GenericFormType<FormValues> }) => (
          <TextModeConfig
            form={form}
            providers={providers}
            languages={languages}
            nodeVars={nodeVars}
          />
        ),
      }, */
    ],
    [baseFields, providers, languages, nodeVars],
  )

  const callback = useCallback(
    (data: FormValues) => ({
      ...data,
      websocket_endpoint: data.websocket_endpoint?.trim(),
    }),
    [],
  )

  return <GenericSidebarComponent fields={allFields} callback={callback} {...props} />
}
